import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Loader2 } from "lucide-react";

// Quitting, applying the update and relaunching takes several seconds with no
// feedback — block the whole screen (same pattern as SellerSwitchOverlay) so
// the app doesn't look interactive-but-dead. Portaled to <body> because
// ancestor transforms would otherwise make `fixed` position against them.
export function RestartingOverlay() {
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-3 bg-background/80 backdrop-blur-sm">
      <Loader2 className="size-6 animate-spin text-muted-foreground" />
      <span className="text-sm text-muted-foreground">
        Restarting to apply the update… please wait
      </span>
    </div>,
    document.body,
  );
}

export function useInstallUpdate() {
  const [restarting, setRestarting] = useState(false);

  // If the app is still alive well past a normal quit-and-install, something
  // went wrong — drop the overlay instead of bricking the UI forever.
  useEffect(() => {
    if (!restarting) return;
    const timeoutId = setTimeout(() => setRestarting(false), 30_000);
    return () => clearTimeout(timeoutId);
  }, [restarting]);

  const installUpdate = useCallback(() => {
    setRestarting(true);
    void window.api?.updater.install();
  }, []);

  return { restarting, installUpdate };
}
